<template>
  <div class="darkbg" @click="changePage('')"></div>
  <div class="loginpage mobile-modal-takeover" v-if="!loginsuccess">
    <div class="block" style="margin:1rem 0;padding:0;">
      <div class="r " style="flex-direction:row;margin-right:0;padding-right:0;">
        <div class="left_c title" style=" width: 90%">

        </div>
        <div class="right_c title " style="margin-right:-1rem;margin-right:0;padding-right:0;width: 10%"
          @click="closeWin" v-if="hideClose != 1">
          <img src="/images/icon_close.png" style="width: 19px; height: 19px; object-fit: cover" />
        </div>
      </div>
    </div>

    <div class="log-box">

      <div class="e-log-box">
        <ErrorBanner v-if="errorState.show" :errorMessage="errorState.message"
          @click="errorState.clickHandler ? errorState.clickHandler() : null" />
        <div class="block">
          <div class="row signup-title" style="flex-direction:row;">
            <div class="left_c title" style="justify-content: left; width: 90%">

              {{ t('register.title') }}

            </div>
            <div class="right_c title" style="width: 10%" @click="closeWin" v-if="hideClose != 1">

            </div>
          </div>
        </div>

        <el-form class="" ref="rieForms" :inline="true" autocomplete="off" :model="rieForm" :rules="rules">
          <!-- :class="command == 'a'?'red-placeholder':''" -->
          <div class="pc_field">
            <div class="tab-box">
              <div class="tab-name">{{ t('common.firstName') }}<span class="star">*</span></div>
            </div>
            <div class="tab-box">
              <div class="tab-name">{{ t('common.lastName') }}<span class="star">*</span></div>
            </div>
            <el-form-item label="" prop="firstname">
              <el-input v-model="rieForm.firstname" :placeholder="t('common.firstName')"></el-input>
            </el-form-item>
            <el-form-item label="" prop="lastname">
              <el-input v-model="rieForm.lastname" :placeholder="t('common.lastName')"></el-input>
            </el-form-item>
          </div>
          <div class="m_field">

            <div class="tab-box" style="width: 100%">
              <div class="tab-name">{{ t('common.firstName') }}<span class="star">*</span></div>
            </div>

            <el-form-item label="" prop="firstname" style="width: 100%">
              <el-input v-model="rieForm.firstname" :placeholder="t('common.firstName')"></el-input>
            </el-form-item>

            <div class="tab-box" style="width: 100%">
              <div class="tab-name">{{ t('common.lastName') }}<span class="star">*</span></div>
            </div>

            <el-form-item label="" prop="lastname" style="width: 100%">
              <el-input v-model="rieForm.lastname" :placeholder="t('common.lastName')"></el-input>
            </el-form-item>

          </div>


          <div class="tab-box" style="width: 100%">
            <div class="tab-name">{{ t('common.email') }}<span class="star">*</span></div>
          </div>

          <el-form-item label="" prop="email" style="width: 100%">
            <el-input autocomplete="off" v-model="rieForm.email" :placeholder="t('common.email')"></el-input>
          </el-form-item>


          <div>
            <div class="tab-box" style="width: 100%">
              <div class="tab-name">{{ t('common.phone') }}<span class="star">*</span></div>

            </div>
            <el-form-item label="" prop="telpre" style="width: 25%">
              <el-select v-model="rieForm.telpre" placeholder="" :teleported="false">
                <el-option-group v-for="continent, idx in countryCodes" :key="idx" :label="continent.name">
                  <el-option v-for="country, idx in continent.countries" :value="country.code + ',' + country.name"
                    :key="idx" :label="country.code">
                    ({{ country.code }}){{ country.name }}
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>

            <el-form-item label="" prop="telephone" style="width: 75%">
              <el-input autocomplete="off" v-model="rieForm.telephone" :placeholder="t('common.phoneNumber')"
                :class="sendclick && rieForm.telephone == '' ? 'red-placeholder' : ''"></el-input>
              <span v-if="smsPlaceholder" style="color:#f56c6c;font-size:10px;line-height:11px;">{{ smsPlaceholder
              }}</span>
            </el-form-item>

            <div class="tab-box" style="width: 100%">
              <div class="tab-name">{{ t('common.verification') }}<span class="star">*</span></div>
            </div>

            <el-form-item label="" prop="smsCode" style="width: 100%">
              <el-input autocomplete="off" v-model="rieForm.smsCode" @input="validsmscode"
                :placeholder="t('common.verificationCode')" ref="smsInput" style="width: 100%; float: left">
                <template #suffix>
                  <span v-if="verified" :class="'secondBtn second2'">
                    {{ t('common.verified') }}

                  </span>
                  <span v-else-if="showBtn == 0" @click="getSmsCode" style="cursor: pointer"
                    :class="(rieForm.firstname.trim() == '' || rieForm.lastname.trim() == '' || rieForm.email.trim() == '' || !isValidEmail(rieForm.email) || rieForm.telephone.trim() == '') ? 'secondBtn second1' : 'secondBtn second2'">
                    {{ regetCode ? t('common.resend') : smsTitle }}
                  </span>
                  <span v-else-if="showBtn == 1" class="secondBtn">
                    <el-icon class="is-loading">
                      <Refresh />
                    </el-icon>
                  </span>
                  <span v-else class="secondBtn second1">
                    {{ second }}
                  </span>
                </template>
              </el-input>
              <span v-if="showBtn == 2 && this.code != ''" style="color:#f56c6c;font-size:10px;line-height:11px;">
                {{ code_tips }}
              </span>
            </el-form-item>
          </div>


          <div class="">
            <div class="tab-box" style="width: 100%">
              <div class="tab-name">{{ t('common.password') }}<span class="star">*</span></div>
            </div>

            <el-form-item label="" prop="password" style="width: 100%">
              <el-input autocomplete="off" v-model="rieForm.password" :placeholder="t('common.password')"
                show-password></el-input>
            </el-form-item>

            <div class="tab-box" style="width: 100%">
              <div class="tab-name">{{ t('common.confirmPassword') }}<span class="star">*</span></div>
            </div>

            <el-form-item label="" prop="confirm" style="width: 100%">
              <el-input autocomplete="off" v-model="rieForm.confirm" :placeholder="t('common.confirmPassword')"
                show-password></el-input>
              <span v-if="math_error != ''" style="color:#f56c6c;font-size:10px;line-height:11px;">
                {{ math_error }}
              </span>

            </el-form-item>
          </div>
        </el-form>
      </div>

      <div class="forgrt-box" style="display: flex; color: #333; font-size: 12rpx; padding-left: 0px">
        <!--  <el-checkbox v-model="rieForm.agree" fill="#00F1BD"></el-checkbox>  -->
        <div style="padding-left: 0px; margin-left: 0px">
          <div @click="agree" v-if="rieForm.agree" class="checkbox agree">✓</div>
          <div @click="agree" v-else-if="!rieForm.agree && submited" class="checkbox noagree"></div>
          <div @click="agree" v-else class="checkbox"></div>
        </div>
        <div style="word-break: break-word; font-size:1.1083rem">
          <span v-html="t('register.agreeTxt')"></span>
          <span class="star">*</span>
        </div>
      </div>
      <div class="forgrt-box" style="display: flex; color: #333; font-size: 12rpx; padding-left: 0px">
        <div style="padding-left: 0px; margin-left: 0px">
          <div @click="agreeSmsTerms" v-if="rieForm.agreeSmsTerms" class="checkbox agree">✓</div>
          <div @click="agreeSmsTerms" v-else class="checkbox"></div>
        </div>
        <div style="word-break: break-word; font-size:1.1083rem">
          <span v-html="t('register.smsText')"></span>
          <ul v-html="t('register.smsTextItems')" class="sms-text-item">
          </ul>
        </div>
      </div>

      <!--
        Previous Error Log Popup
        now replace with ErrorBanner, leave for possible future use
        <div v-if="error != ''" class="error">
          <WarningIcon />{{ error }}
        </div>
      -->

      <!-- sign up form submit button -->
      <div class="btn-box" :class="{ 'deactivate': !isFormFilled || isExistingUser }" v-gtag:click="'customer_register'"
        @click="regsubmit">
        {{ t("login.createAnAccount") }}
      </div>

      <div class="yy-box" @click="changePage('login')">
        {{ t("register.already") }}

        <span style="padding-left: 5px">{{ t('login.logIn') }} </span>
      </div>
    </div>
  </div>
  <div v-else>
    <AlertDialog @closeWin="closeWin" status="success" :title="t('common.SUCCESSFUL')"
      :content="successContent" />
  </div>
</template>
<script>

import { computed } from "vue";
import Request from '@/services/Request'
import AlertDialog from '@/components/alertdialog.vue'
import { getDaysFromYYYYMM, validatePhoneNumber, isValidEmail } from '@/utils/tool.js'
import {  pagelog } from '@/utils/pagelog'
import { countryCodes } from '@/utils/AddressUtils'
import { Warning as WarningIcon } from '@element-plus/icons-vue'
import '@/assets/main.css'
import { useUserStore } from '@/stores/UserStore'
import vGtag from '@/directives/GtagDirective'
import { useI18n } from 'vue-i18n';
import ErrorBanner from './signUp/errorBanner.vue'
import { getCaptchaToken } from "@/utils/ReCaptchaUtils";
import { localDriver } from '@/utils/localDriver'

export default {
  components: { AlertDialog, WarningIcon, ErrorBanner },
  directives: { gtag: vGtag },
  emits: ['changePage', 'gotoNext'],
  props: ['hideClose'],

  data() {
    return {
      isValidEmail,
      validatePhoneNumber,
      pagelog,
      login_need: false,
      countryCodes: countryCodes,
      isLogin: false,
      rieForm: {
        //newsletter:true,
        agree: false,
        agreeSmsTerms: false,
        telpre: '+1',
        firstname: '',
        telephone: '',
        lastname: '',
        email: '',
        smsCode: '',
        password: '',
        confirm: '',
        Birth: '',
        Gender: '',
        year: '1980',
        month: '',
        day: ''
        // act:'checkout'
      },

      flag: '',
      usdvalue: '',

      email: '',
      input2: '',
      password: '',

      options: [],
      smsPlaceholder: '',
      code: '',
      smsTitle: 'Get Code',
      sendclick: false,
      submited: false,
      showBtn: 0,
      second: 60,
      error: '',
      success: '',
      loginsuccess: false,
      regetCode: false,
      years: Array.from({ length: 2010 - 1930 + 1 }, (v, k) => k + 1930),
      months: Array.from({ length: 12 }, (v, k) => (k + 1).toString().padStart(2, '0')),
      days: [],
      code_tips: "",
      math_error: "",
      verified: false,
      isFormValid: true,
      isNetworkError: false,
      isExistingUser: false,
    }
  },
  setup() {
    const { t, locale } = useI18n();
    const userStore = useUserStore()
    const user = userStore.user;
    const rules = computed(() => ({

      password: [
        {
          required: true,
          message: t("common.cantEmpty"),
          trigger: 'blur'
        }
      ],
      confirm: [
        {
          required: true,
          message: t("common.cantEmpty"),
          trigger: 'blur'
        }
      ],

      firstname: [
        {
          required: true,
          message: t("common.cantEmpty"),
          trigger: 'blur'
        },
        {
          pattern: /^[A-z][a-zA-Z ]{1,30}$/,
          message: t("common.enterName"),//'Please enter the correct name',
          trigger: 'blur'
        }
      ],
      lastname: [
        {
          required: true,
          message: t("common.cantEmpty"),
          trigger: 'blur'
        },
        {
          pattern: /^[A-z][a-zA-Z ]{1,30}$/,
          message: t("common.enterName"),
          trigger: 'blur'
        }
      ],
      email: [
        {
          required: true,
          message: t("common.cantEmpty"),
          trigger: 'blur'
        },
        {
          pattern: /^\s*\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+\s*$/,
          message: t("common.enterEmail"),
          trigger: 'blur'
        }
      ],
      confirmemail: [
        {
          required: true,
          message: t("common.cantEmpty"),
          trigger: 'blur'
        },
        {
          pattern: /^\s*\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+\s*$/,
          message: t("common.enterEmail"),
          trigger: 'blur'
        }
      ],
    }));

    /*  password: [{ required: true, message: t("common.cantEmpty"), trigger: "blur" }],
 
     email: [
       { required: true, message: t("common.cantEmpty"), trigger: "blur" },
       { pattern: /^\s*\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+\s*$/, message: t('common.enterEmail'), trigger: "blur" }
     ] */

    return { userStore, user, t, locale, rules }
  },
  watch: {
    'rieForm.telephone': function (newVal, oldVal) {
      ////console.log(this.smsPlaceholder);
      this.smsPlaceholder = "";
      // Reset existing user error when phone changes
      if (this.isExistingUser) {
        this.isExistingUser = false;
      }
    },
    'rieForm.email': function (newVal, oldVal) {
      // Reset existing user error when email changes
      if (this.isExistingUser) {
        this.isExistingUser = false;
      }
    },
    'rieForm.month': function (newVal, oldVal) {
      this.updateDays()
    },
    'rieForm.year': function (newVal, oldVal) {
      this.updateDays()
    },

    'rieForm.day': function (newVal, oldVal) {
      this.setBirth()
    }
  },
  created() {
    this.code_tips = this.t('register.sendCodeTips');
    this.smsTitle = this.t('common.getCode');
  },
  /*   setup: () => {
      const userStore = useUserStore()
      const user = userStore.user
      return { userStore, user }
    }, */
  methods: {
    setBirth() {
      if (this.rieForm.year && this.rieForm.month && this.rieForm.day) {
        this.rieForm.Birth = new Date(this.rieForm.year, this.rieForm.month - 1, this.rieForm.day)
      }
    },
    updateDays() {
      this.days = getDaysFromYYYYMM(this.rieForm.year, this.rieForm.month)
    },
    async getSmsCode() {
      /*  if (this.smsTitle == 'Enter Code') {
         return false;
       } */
      this.success = '';
      this.error = '';
      this.sendclick = true;
      this.code_tips = "";
      // phone number is empty
      if (this.rieForm.telephone.trim() == '') {
        this.smsPlaceholder = this.t('common.cantEmpty');//"This field cannot be empty"
        return false
      }
      // above mandatory info hasn't filled
      else if (this.rieForm.email.trim() == '' ||
        !this.isValidEmail(this.rieForm.email) ||
        this.rieForm.firstname.trim() == '' ||
        this.rieForm.lastname.trim() == '') {
        // this.smsPlaceholder = "This field cannot be empty"
        return false
      }
      // validate phone number format
      else {
        let c = validatePhoneNumber(this.rieForm.telephone);
        if (!c) {
          this.smsPlaceholder = this.t('common.enterCorrectPhone');
          return false
        }
      }
      // get sms verification code
      //  var elem = this.$refs.smsInput
      const area = this.rieForm.telpre.split(',')[0]
      var postdata = {
        firstname: this.rieForm.firstname,
        phone: area + this.rieForm.telephone,
        area: area,
        mobile: this.rieForm.telephone,
        email: this.rieForm.email,
        checkphone: '1',
        captchaToken: await getCaptchaToken('smsCode')
      }
      // console.log(postdata);
      this.smsPlaceholder = '';
      this.showBtn = 1;
      new Request().webPost(
        postdata,
        (res) => {
          //console.log(res);
          if (res.success) {
            this.code_tips = this.t('register.sendCodeTips');
            this.showBtn = 2;
            this.second = 60;
            this.timer = setInterval(() => {
              if (this.second > 0) this.second--
              if (this.second == 0) {
                clearInterval(this.timer);
                this.regetCode = true;
                this.showBtn = 0;
              }
            }, 1000);
            this.code = res.data.code
            //console.log('code:', this.code)
          } else {
            this.error = res.msg;
            this.smsPlaceholder = res.msg;
            this.showBtn = 0;
          }
        },
        'account/register/smsCode',
        (err) => {
          // console.log(err);
          this.error = err.message;
          this.smsPlaceholder = err.message;
          this.showBtn = 0;
        })
    },

    changePage(page) {
      if (page == "register") {
        this.userStore.showLoginDlg = 'register'
      }
      else if (page == "login") {
        this.userStore.showLoginDlg = 'login'
      }
      else if (page == "recoverpass") {
        this.userStore.showLoginDlg = 'recoverpass'
      }
      this.$emit('changePage', page)
    },
    closeWin() {
      this.$emit('close') // 当点击关闭按钮时，触发close事件
    },
    agree() {
      this.rieForm.agree = !this.rieForm.agree
    },
    agreeSmsTerms() {
      this.rieForm.agreeSmsTerms = !this.rieForm.agreeSmsTerms
    },

    needfields() {
      return '' != this.rieForm.firstname && '' != this.rieForm.telephone
    },
    onFinish() {
      this.showBtn = 0;
    },

    refeshSmsCode() {
      this.code = ''
      this.smsTitle = this.t('common.getCode');//'Get Code'
    },
    validsmscode() {
      this.rieForm.smsCode = (this.rieForm.smsCode != '' ? this.rieForm.smsCode.replace(/[^0-9]/g, '').slice(0, 6) : '');

      if (this.rieForm.smsCode.length == 6 && this.rieForm.smsCode == this.code) {
        this.verified = true;
        this.code_tips = '';
      }
      else this.verified = false;

    },

    parseQueryString(url) {
      const queryString = url.split('?')[1]
      const params = {}
      if (queryString) {
        queryString.split('&').forEach((pair) => {
          var [key, value] = pair.split('=')
          key = key == 'route' ? 'url' : key
          params[decodeURIComponent(key)] = decodeURIComponent(value)
        })
      }
      return params
    },
    async formvalidater() {
      await this.$nextTick();
      const form = this.$refs.rieForms;
      if (!form) return false;
      return new Promise((resolve) => {
        form.validate((valid) => resolve(valid?true:false));
      });      
    },
    async regsubmit() {
      this.smsPlaceholder = '';
      this.code_tips = "";
      this.math_error = "";
      this.isNetworkError = false;
      this.isExistingUser = false;

      // this.$emit('gotoNext');
      // console.log("ddd");
      // return;
      this.submited = true
      this.rieForm.ref_accountid = ''
      const ref_accountid = await localDriver.getItem('ref_accountid')
      if (ref_accountid) {
        this.rieForm.ref_accountid = ref_accountid
      }

      await this.formvalidater().then(async (isFormCompleted) => {
        if (this.rieForm.smsCode == "") {
          this.code_tips = this.t('common.cantEmpty');//
          this.isFormValid = false;
          return false
        }
        if (this.rieForm.telephone == "") {
          this.smsPlaceholder = this.t('common.cantEmpty');//"This field cannot be empty"
          this.isFormValid = false;
          return false
        }
        else {
          let c = validatePhoneNumber(this.rieForm.telephone);
          if (!c) {
            this.smsPlaceholder = this.t('common.enterCorrectPhone');// "Please enter the correct Phone Number";
            this.isFormValid = false;
            return false
          }
        }
        if (!this.rieForm.agree) {
          console.log("no agree");
          this.isFormValid = false;
          return false;
        }
        if (!isFormCompleted) {
          //  this.error="Something wrong!";
          console.log("not com");
          this.isFormValid = false;
          return false
        }
        // console.log("go");
        if (this.rieForm.password != this.rieForm.confirm) {
          //  console.log("nomathc");
          //this.error = "Please make sure your passwords match";
          this.math_error = this.t("register.noMatch");//"Please make sure your passwords match";
          this.isFormValid = false;
          return false
        }
        // else console.log("math");
        this.isFormValid = true;
        this.success = ''
        this.error = ''
        this.rieForm.telpre = this.rieForm.telpre.split(',')[0];
        console.log("ti", this.rieForm);
        try {
          const succ = await this.userStore.register(this.rieForm)
          this.pagelog(new Request(), 'registerSms', { smsCode: this.smsCode, success: succ });
          if (succ) {
            this.success = this.t('register.regSuccess');// 'Registration successful!'
            this.loginsuccess = true;
            await localDriver.setItem('ref_accountid', "");
          }
          else {
            if (this.userStore.serverErrors.length > 0) {
              this.error = this.userStore.serverErrors[0];
            }
            this.isExistingUser = this.userStore.serverErrors.find((error) =>
              // use string includes to check for existing user error since the error message from server may vary
              error.includes('This email address is already associated with an account.')
            );
            if (!this.isExistingUser) {
              this.isNetworkError = true;
            }
          }
        } catch (error) {
          this.isNetworkError = true;
          this.error = error.message;
        }
      })
    }
  },
  computed: {
    // Success dialog text; appends the register-coupon line when a coupon was granted at signup.
    successContent() {
      let content = this.t('register.successDesc');
      const c = this.userStore.registerCoupon;
      if (c && c.code) {
        const amount = c.type === 'F' ? `${c.currency || '$'}${c.amount}` : `${c.amount}%`;
        content += '\n\n' + this.t('register.couponGranted', { amount: amount, code: c.code, days: c.duration });
      }
      return content;
    },
    isFormFilled() {
      // mandatory info hasn't filled
      const requiredFields = ['firstname', 'lastname', 'email', 'telephone', 'smsCode', 'password', 'confirm'];
      for (const field of requiredFields) {
        if (!this.rieForm[field] || this.rieForm[field].trim() === '') {
          return false; // If any required field is empty, return false
        }
      }
      // validate phone number format
      let c = validatePhoneNumber(this.rieForm.telephone);
      if (!c) {
        this.smsPlaceholder = this.t('common.enterCorrectPhone');
        return false
      }
      // Ensure the user has agreed to mandatory terms
      return this.rieForm.agree;
    },
    errorState() {
      if (!this.isFormValid) {
        return {
          show: true,
          message: this.t('register.infoMissing'),
          clickHandler: this.regsubmit()
        };
      } else if (this.isExistingUser) {
        return {
          show: true,
          message: this.t('register.userExists'),
          clickHandler: null
        };
      }
      else if (this.error !== null && this.error !== '') {
        return {
          show: true,
          message: this.error,
          clickHandler: null
        };
      }
      else if (this.isNetworkError) {
        return {
          show: true,
          message: this.t('register.networkError'),
          clickHandler: null
        };
      }

      return { show: false, message: '', clickHandler: null };
    }
  },
}
</script>
<style lang="scss">
.tip {
  border-radius: 10px;
  border: 1px solid var(--text-red, #F92D2D) !important;


  background: #FFF4F4;
  margin-bottom: 2rem;
  padding: 2rem;
  font-size: 1.2rem;

}

.tip .left_c {
  width: 7%;
}

.tip .right_c {
  width: 93%;
}

.secondBtn {
  width: 80px;
  padding: 0px 15px;
  margin-right: 0;
  height: 35px;
  line-height: 35px;
  width: 120px;
  border-radius: 10px;
  text-align: center;
  font-size: 1.3rem;
  color: #333;
  font-weight: bold;
  background-color: #00F1BD;
}

.second1 {
  opacity: 0.3;
  color: rgba(255, 255, 255, 1);
}

.second2 {
  cursor: pointer;
}

.el-date-editor.el-input,
.el-date-editor.el-input__wrapper {
  font-size: 1.5rem;
}
</style>
<style lang="scss" scoped>
.title {
  font-size: 17px;
  font-weight: bold;
}

.checkbox {
  background: #fff;
  width: 16px;
  height: 16px;
  border: 1px #ccc solid;
  border-radius: 3px;
  cursor: pointer;
  font-size: 1.4083rem;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.agree {
  background: #00f1bd;
  border: 1px #00f1bd solid;
  font-size: 1.4083rem;
}

.noagree {
  background: #fff;
  border: 1px solid red;
}

.red-placeholder ::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: red !important;
  opacity: 1;
  /* Firefox */
}

.red-placeholder :-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: red !important;
}

.red-placeholder ::-ms-input-placeholder {
  /* Microsoft Edge */
  color: red !important;
}

.el-divider--horizontal {
  width: 60% !important;
  margin: 0 auto;
}

.log-success-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 813rpx;
  height: 782rpx;
  flex-shrink: 0;
  border-radius: 33px;
  border-radius: 33px;
  background: #fff;
  z-index: 99;
}

:deel(.el-dialog) {
  top: -75px;
  border-radius: 33px;

  .el-dialog__header {
    font-weight: bold;
    border: 0px solid red;
    padding-top: 30px;
    text-align: center;

    .el-dialog__headerbtn {
      font-size: 2.8167rem;
      font-weight: 700;
      color: #000;
    }
  }
}

* {
  padding: 0;
}

.el-select-dropdown__item {
  padding: 0 20px;
}

.log-box {
  .yy-box {
    text-align: center;
    margin-top: 24px;

    font-size: 1.4083rem;
    font-family: Poppins;
    font-weight: 400;
    color: #a6a6a6;

    span {
      color: #4ca771;
      cursor: pointer;
    }
  }

  .btn-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px 0;
    width: 100%;
    height: 48px;
    background: #00F1BD;
    border-radius: 8px;
    opacity: 1;
    font-size: 1.7333rem;

    font-weight: bold;
    color: #333;
    cursor: pointer;
  }

  .deactivate {
    opacity: 0.3;
    color: rgba(255, 255, 255, 1);
    cursor: default;
  }

  .forgrt-box {
    font-size: 1.5167rem;

    font-weight: 400;
    color: #00f1bd;
    line-height: 20px;
    cursor: pointer;
    margin-top: 16px;

    .sms-text-item {
      margin-left: 10px;
    }

    .star {
      color: red;
      padding-left: 5px;
    }

    :deel(.el-checkbox) {
      .el-checkbox__inner {
        height: 16px;
        width: 16px;
        border-color: #aaa;

        border-radius: 2px;
      }

      .el-checkbox__input.is-checked .el-checkbox1__inner {
        background-color: #00f1bd;
        border-color: #aaa;
      }

      .el-checkbox__inner:hover {
        border-color: #aaa;
      }

      .el-checkbox__inner::after {
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%) scale(1.2) rotate(45deg);
      }

    }

    div {
      font-size: 1.4083rem;
      margin-right: 5px;
    }
  }

  .e-log-box {
    .signup-title {
      padding-left: 0;
      padding-right: 0;
    }

    :deep(.el-form) {
      .el-form-item {
        vertical-align: middle;
        width: 50%;
        margin: 0;
        padding: 0px;
        border: 0px solid red;
        height: 35px;
        padding-right: 16px;
        margin-bottom: 20px;

        .el-select__wrapper //下拉框

          {
          border-radius: 10px;

          background: #f5f5f5;
          border: 0px solid red;
          box-shadow: 0 0 0 0;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          width: 100%;

          .el-date-editor--date {
            width: 100%;
          }

          .el-select {
            width: 100%;
          }

          .input-with-select {
            border-radius: 45px;
            padding: 4px 7px 4px 0;

            &.el-input .el-input__inner {
              border: none;

              padding-left: 10px;

              &::placeholder {
                color: #cfcfcf;
              }
            }

            .el-input-group__append {
              border-radius: 10px;
              font-weight: bold;
              cursor: pointer;
            }
          }

          .el-date-editor {
            .el-input__wrapper {
              color: #333;
              border-radius: 10px;
              border: 0px solid red;
              background: #f5f5f5;
              height: 48px;
              font-size: 1.5rem;
              font-family: Poppins;
              line-height: 48px;
              padding-left: 0;

              &::placeholder {
                color: #a6a6a6;
              }
            }
          }

          .el-select {
            .el-select__wrapper {
              color: #333;
              border-radius: 10px;
              border: 0px solid red;
              background: #f5f5f5;
              font-family: Poppins;
              height: 35px;
              line-height: 35px;
              font-size: 1.5rem;
              padding-left: 10px;

              &::placeholder {
                color: #a6a6a6;
              }
            }
          }

          .el-input {
            .el-input__inner {
              color: #333;
              border-radius: 10px;
              border: 0px solid red;
              font-family: Poppins;
              background: #f5f5f5;
              height: 35px;
              font-size: 1.5rem;
              line-height: 35px;
              padding-left: 10px;

              &::placeholder {
                color: #a6a6a6;
              }
            }

            .el-input__suffix .el-input__icon.el-icon-arrow-up {
              color: #333;
            }
          }
        }
      }

      .el-input-group__append {
        background: #00f1bd;
        border: 1px solid #00f1bd;
      }
    }
  }

  .tab-box {
    margin: 1.3rem 0 6px;
    width: 50%;
    float: left;

    .star {
      color: red;
      padding-left: 5px;
    }

    .active {
      color: #00f1bd !important;
    }

    .tab-name {
      font-size: 1.5167rem;
      font-weight: 500;
      color: #666;
      font-family: Poppins;
      margin-right: 25px;
      cursor: pointer;
    }
  }
}

.fb-btn {
  display: flex;
  margin-bottom: 10px;
  padding: 0 25px;

  div {
    flex: 1;
    height: 40px;
    border-radius: 25px;
    opacity: 1;
    border: 2px solid #a6a6a6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4083rem;
    font-family: Poppins;
    font-weight: 400;
    color: #333333;
    cursor: pointer;

    &:first-child {
      margin-right: 10px;
    }
  }
}

.primaryColor {
  color: #00f1bd;
}

.custom-checkbox .el-checkbox__inner {
  border-color: #00f1bd !important;
}

/* 当checkbox被hover时也改变边框颜色 */
.custom-checkbox:hover .el-checkbox__inner {
  border-color: #00f1bd !important;
}

/* 当checkbox被选中时，改变对号的颜色以适应新的边框颜色 */
.custom-checkbox.is-checked .el-checkbox__inner {
  border-color: #00f1bd !important;
}

.custom-checkbox.is-checked .el-checkbox__inner::after {
  border-color: #00f1bd !important;
}

:deel(.el-cascader-node.in-active-path),
:deel(.el-cascader-node.is-active),
:deel(.el-cascader-node.is-selectable.in-checked-path) {
  color: #00f1bd;
}

:deel(.el-dropdown-menu__item) {
  padding: 10rpx 20rpx;

  text-align: center;
}

:deel(.share-adventure-wrap) {
  background-color: red;
}

:deel(.el-dropdown-menu__item:hover) {
  background-color: #00f1bd;
  color: #fff;
}

:deel(.el-dropdown-menu__item:focus) {
  background-color: #00f1bd;
  color: #fff;
}

:deel(.el-dropdown-menu) {
  padding: 0 !important;
}

.el-dropdown-menu {
  padding: 0 !important;
  border-radius: 15px;
  text-align: center;
  overflow: hidden;
}

.darkbg {
  z-index: 999998;
}

.loginpage {
  position: fixed;
  width: 568px;
  box-sizing: border-box;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;

  border: 1px solid #e5e5e5;
  border-radius: 12px;
  z-index: 999999;
  background: #fff;
  padding: 32px 40px;
  padding-top: 0;
  font-size: 1.4083rem;
  max-height: 90%;
  overflow-y: scroll;
  /* 隐藏滚动条的技巧 */
  -ms-overflow-style: none;
  /* IE 和 Edge */
  scrollbar-width: none;
  /* Firefox */
}

.country-item {
  display: flex;
  align-items: center;

  .country-img {
    width: 20rpx;
    height: 20rpx;
  }

  .country-txt {
    font-size: 1.1917rem;
    margin-left: 3px;
  }
}

:deep(.pc_field) {
  display: block;
}

:deep(.m_field) {
  display: none;
}
</style>


<!-- 移动端 -->
<style scoped>
@media screen and (max-width: 750px) {

  /*  :deep(body)
  {
    overflow-y:hidden;
  } */
  .secondBtn {

    font-size: 1.2rem;
  }

  :deep(.el-select__selected-item) {
    height: auto !important
  }

  .log-box .tab-box {
    margin: 0.2rem 0 6px;
  }

  .btn-box {

    font-size: 1.4rem !important
  }

  .log-box .tab-box .tab-name {
    font-size: 1.3rem;
  }

  /*   :deep(.log-box .e-log-box .el-form .el-form-item .el-form-item__content .el-input .el-input__inner) {
  
    height: 4rem;
    font-size: 1.4rem!important;
    line-height: 4rem;

} */
  .title {
    font-size: 1.5rem;
  }

  :deep(.pc_field) {
    display: none;
  }

  :deep(.m_field) {
    display: block;
  }

  .loginpage {
    width: 80%;
    padding: 20px;
    padding-top: 0;
  }

  .loginpage.mobile-modal-takeover {
    top: 0 !important;
    right: 0 !important;
    bottom: var(--mobile-nav-height, 0px) !important;
    left: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    max-height: none !important;
    margin: 0 !important;
    padding: 20px !important;
    border-radius: 0 !important;
    transform: none !important;
    overflow-y: auto !important;
  }

  :deep(.el-date-editor.el-input),
  .el-date-editor.el-input__wrapper {
    height: 30px !important;
    font-size: 1.3rem;
    width: 100% !important;
  }

  html,
  body {
    line-height: 25px !important;
  }
}
</style>
